import type { IDataViewFilters } from '@/domains/investor/components/DataView/DataViewFilters/DataViewFilters.types'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'

export const useGeneralMeeting = async (
  filters: MaybeRefOrGetter<IDataViewFilters>,
  page: MaybeRefOrGetter<number>,
  perPage: number,
  cacheKey = 'investor-general-meetings',
) => {
  const { useList } = useDataView()

  const { items: generalMeetings, columns: generalMeetingColumns, total, isLoading } = await useList({
    cacheKey,
    filters,
    page,
    perPage,
    baseKey: 'investor.generalMeeting.dataView',
    linkTextKey: 'investor.generalMeeting.dataView.table.link.text',
  })

  return {
    generalMeetings,
    generalMeetingColumns,
    total,
    isLoading,
  }
}
